export const constAlert = {
    show: false,
    appearance: 'border',
    dismissible: true,
    dismissed: false,
    name: "'mainToast'",
    type: null,
    title: null,
    message: null
};
